module.exports = "<p-editor [(ngModel)]=\"html\" [style]=\"{'height':'auto','width':'100%'}\" [readonly]=\"true\">\r\n\t<p-header>\r\n\t</p-header>\r\n</p-editor>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/utility/editor-display/editor-display.component.html
// module id = ./src/app/components/utility/editor-display/editor-display.component.html
// module chunks = main